import Button from './Button'
import './ExpandableButton.css'

export default function ExpandableButton({ expanded, className = '', children, type = 'button', ...props }) {
  return (
    <Button
      {...props}
      variant="secondary"
      className={`sb-expandable-button${className ? ` ${className}` : ''}`}
      type={type}
      aria-expanded={expanded}
    >
      {children}
    </Button>
  )
}
